export default "__VITE_ASSET__D3HRSaEh__"